module.exports = __webpack_public_path__ + "img/pinball.c64dac6b.svg";